import React, { useState } from 'react';
import styles from './style.module.scss';
import {
    Card,
    Container,
    Button,
    TextField,
    InputAdornment,
    FormControl,
    MenuItem,
    InputLabel,
    Select,
    DialogTitle,
    DialogContent,
    Dialog,
    Grid,
    FormHelperText
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import { Category } from './constant';
import { makeStyles } from "@material-ui/core/styles";
import { handleTypeNumber, CapitalizeFirstLetter } from '../../utils/validation';


const CatalogueComponent = (props) => {
    const useStyles = makeStyles({
        root: {
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e9ecef",
                borderRadius: '30px',
                boxShadow: 'rgb(17 17 26 / 5%) 0px 1px 0px, rgb(17 17 26 / 10%) 0px 0px 8px'
            },
            "& .MuiOutlinedInput-adornedStart": {
                paddingLeft: '25px'
            },
            "& .MuiInputAdornment-positionStart": {
                marginRight: '18px'
            },
            "& .MuiOutlinedInput-adornedEnd": {
                paddingRight: '25px'
            },
        },
        paper: { height: "calc(100vh - 100px)", width: 'calc(100% - 100px)' },
        select: {
            "&:focus": {
                backgroundColor: "white"
            }
        }
    });
    const classes = useStyles();
    const [errorMsg, setErrorMsg] = useState({ quantity: null, price: null, category: null, brand: null, model: null });

    //function to check validations
    const checkFieldsValidation = (e) => {
        if (e.target.name === 'model' || e.target.name === 'category' || e.target.name === 'brand') {
            if (!e.target.value)
                setErrorMsg({ ...errorMsg, [e.target.name]: `${CapitalizeFirstLetter(e.target.name)} is required.` })
        }
        else if ((e.target.name === 'price' && !e.target.value) || (e.target.name === 'quantity' && !e.target.value)) {
            setErrorMsg({ ...errorMsg, [e.target.name]: `${CapitalizeFirstLetter(e.target.name)} is required.` })
            return true
        }
        else if (props.addProductObj.type !== 'new' && parseInt(props.addProductObj.price) > props.addProductObj.mrp) {
            setErrorMsg({ ...errorMsg, price: `Listing price should not be greater than MRP(${props.addProductObj.mrp})` });
            return true
        }
    }

    //function to check form validation
    const checkFormValidation = () => {
        if (props.addProductObj.type === 'new') {
            if (errorMsg.model || !props.addProductObj.model || errorMsg.category || !props.addProductObj.category || errorMsg.brand || !props.addProductObj.brand || errorMsg.quantity || !props.addProductObj.quantity || errorMsg.price || !props.addProductObj.price) {
                return false
            }
            else return true
        }
        else {
            if (errorMsg.model || !props.addProductObj.model || errorMsg.quantity || !props.addProductObj.quantity || errorMsg.price || !props.addProductObj.price) {
                return false
            }
            else return true
        }
    }

    //function to set error msg to false
    const clearErrorMsg = () => {
        setErrorMsg({quantity: null, price: null, category: null, brand: null, model: null });
    }

    //function to set specific field of error to null
    const handleError = (e) => {
        setErrorMsg({ ...errorMsg, [e.target.name]: false });
    }

    return <div >
        <Dialog classes={{ paper: classes.paper }} maxWidth="xl" open={props.show} onClose={() => props.handleClose()} >
            <DialogTitle id="customized-dialog-title" onClose={() => props.handleClose()} className={styles.modalTitle}>
                <div className="d-flex justify-content-between align-items-center">
                    <div >
                        <div className="mb-0">Add Inventory</div>
                    </div>
                    <div>
                        <IconButton className={styles.closeBtn} onClick={() => props.handleClose()}>
                            <CloseIcon className={styles.searchClose} />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent className="m-3" >
                <Container maxWidth="md">
                    <div className="text-muted text-center p-2">Search products already listed on Gostor catalogue to add them into your inventory.</div>
                    <FormControl fullWidth variant="outlined">
                        <TextField id="standard-basic" autoComplete="off" placeholder="Search by model" variant="outlined" autoFocus="true"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon style={{ color: 'grey' }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (props.searchedModelId ? <InputAdornment position="end">
                                    <IconButton className={styles.closeBtn} onClick={() => props.clearSearchResult()}> <CloseIcon className={styles.searchClose} />
                                    </IconButton></InputAdornment>
                                    :
                                    null
                                )
                            }}
                            className={classes.root}
                            value={props.searchedModelId} onChange={(e) => props.searchModelIdFnc(e)} />
                    </FormControl>
                    {props.modelArray && props.modelArray.length > 0 &&
                        <Paper elevation={1} className={styles.autoSearchInput}>
                            {
                                props.modelArray.map((item, index) => {
                                    return <div key={index} className={styles.searchItem} onClick={() => {props.selectedModelFnc(item.model, 'exsisting',item);clearErrorMsg()}}>
                                        {item.display_name} - ({item.model})
                                    </div>
                                })
                            }
                        </Paper>
                    }
                    {props.modelArray && props.modelArray.length === 0 &&
                        <Paper elevation={1} className={styles.autoSearchInput}>
                            {
                                props.modelArray && props.modelArray.length === 0 &&
                                <div className={styles.noData} >
                                    No products found
                                </div>

                            }
                        </Paper>
                    }
                    {props.showAddNewBtn ?
                        <div className={`${styles.noResult} text-muted text-center`}>
                            If the product you are searching is not found ?
                            <br />
                            <Button variant="outlined" color="primary" className="mt-2" onClick={() => props.addProductObj.type !== 'new' ? props.selectedModelFnc(null, 'new') : null}> Raise new catalogue request</Button>
                        </div>
                        :
                        null}
                    {props.showModelDetails ?
                        <Card className={styles.autoModalCard} variant="outlined">
                            {
                                props.addProductObj.type === 'new' ?
                                    <div className={styles.catTitle}>
                                        Fill the details below to request a new catalogue creation.
                                    </div>
                                    :
                                    <div className={styles.catTitle}>
                                        Enter price and quantity to make
                                        <strong> {props.addProductObj.display_name} </strong>  live on Gostor.
                                    </div>
                            }
                            <Grid container spacing={5}>
                                <Grid item md={12}>
                                    <FormControl variant="outlined" className="mb-2" fullWidth>
                                        <TextField id="standard-basic" autoComplete="off" label="Selected Model" name="model" disabled={props.addProductObj.type === 'exsisting'} error={errorMsg.model ? true : false} helperText={errorMsg.model} value={props.addProductObj.model || ''} onChange={(e) => {props.productObj(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} />
                                    </FormControl>
                                </Grid>
                                {
                                    props.addProductObj.type === 'new' ?
                                        <React.Fragment>
                                            <Grid item md={6}>
                                                <FormControl style={{ width: '100%' }} required error={errorMsg.category ? true : false}>
                                                    <InputLabel id="demo-simple-select-label">Select Category</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={props.addProductObj.category || ''}
                                                        onChange={(e) => {props.productObj(e)}}
                                                        onBlur={(e) => checkFieldsValidation(e)}
                                                        variant="standard"
                                                        name="category"
                                                        fullWidth
                                                        helperText={errorMsg.category}
                                                        inputProps={{
                                                            classes: { select: classes.select }
                                                        }}
                                                        onClose={() => {
                                                            setTimeout(() => {
                                                                document.activeElement.blur();
                                                            }, 0);
                                                        }}
                                                    >
                                                        {
                                                            Category.map((cat, index) => {
                                                                return <MenuItem key={index} value={cat.value}>{cat.label}</MenuItem>

                                                            })
                                                        }
                                                    </Select>
                                                    <FormHelperText>{errorMsg.category}</FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={6}>
                                                <FormControl variant="outlined" className="mb-2" fullWidth>
                                                    <TextField id="standard-basic" type="text" autoComplete="off" label="Enter Brand" name="brand" error={errorMsg.brand ? true : false} helperText={errorMsg.brand} value={props.addProductObj.brand || ''} onChange={(e) => {props.productObj(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} />
                                                </FormControl>
                                            </Grid>
                                        </React.Fragment>
                                        : null
                                }
                                <Grid item md={6}>
                                    <FormControl variant="outlined" className="mb-2" fullWidth>

                                        <TextField id="standard-basic" type="number" autoComplete="off" onKeyDown={(evt) => handleTypeNumber(evt)} label="Enter Quantity" name="quantity" error={errorMsg.quantity ? true : false} helperText={errorMsg.quantity} value={props.addProductObj.quantity || ''} onChange={(e) => {props.productObj(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} />
                                    </FormControl>
                                </Grid>
                                
                                <Grid item md={6}>
                                    <FormControl variant="outlined" className="mb-2" fullWidth>
                                        <TextField 
                                            id="standard-basic"
                                            type="number"
                                            autoComplete="off"
                                            onKeyDown={(evt) => handleTypeNumber(evt)}
                                            label="Lowest Online Price"
                                            name="lowest_price"
                                            error={errorMsg.lowest_price ? true : false}
                                            helperText={errorMsg.lowest_price}
                                            value={props.addProductObj.lowest_price || ''}
                                            onChange={(e) => {
                                                props.productObj(e);
                                                handleError(e)
                                            }} 
                                            onBlur={(e) => checkFieldsValidation(e)} 
                                            disabled
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item md={6}>
                                    <FormControl variant="outlined" className="mb-2" fullWidth>
                                        <TextField id="standard-basic" type="number" autoComplete="off" onKeyDown={(evt) => handleTypeNumber(evt)} label="MRP" name="mrp" error={errorMsg.mrp ? true : false} helperText={errorMsg.mrp} value={props.addProductObj.mrp || ''} onChange={(e) => {props.productObj(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} disabled />
                                    </FormControl>
                                </Grid>

                                <Grid item md={6}>
                                    <FormControl variant="outlined" className="mb-2" fullWidth>
                                        <TextField id="standard-basic" type="number" autoComplete="off" onKeyDown={(evt) => handleTypeNumber(evt)} label="Enter Price" name="price" error={errorMsg.price ? true : false} helperText={errorMsg.price} value={props.addProductObj.price || ''} onChange={(e) => {props.productObj(e);handleError(e)}} onBlur={(e) => checkFieldsValidation(e)} />
                                    </FormControl>
                                </Grid>


                                <Grid item className="d-flex align-items-center">
                                    <Button variant="contained" color="primary" className={!checkFormValidation() ? styles.disableBtn : null} disabled={!checkFormValidation()} onClick={() => props.addCatalogueRequest()}>{
                                        props.addProductObj.type === 'new' ?
                                            'Send catalogue request'
                                            : 'Add Inventory'
                                    }</Button>
                                </Grid>
                            </Grid>

                        </Card>
                        :
                        null}
                </Container>
            </DialogContent>
        </Dialog>
    </div>
}

const AddCatalogueComponent = React.memo(CatalogueComponent);

export default AddCatalogueComponent;

